module.exports = __webpack_public_path__ + "static/media/teleport.78d9ec30.mp3";